export const SET_BOOKMARK_DISCARD = "SET_BOOKMARK_DISCARD";